import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';

import css from '../nibTable.module.sass';

const CustomCell = ({
  value: initialValue,
  row: { index, original },
  column: { id },
  rowToEdit,
  updateMyData,
  forceUpdateRow,
  data = {},
}) => {
  if (data.render) {
    return <div className={css.customCell}>{data.render(initialValue, original, rowToEdit)}</div>;
  } else {
    return <div style={{ padding: '0 10px' }}>{initialValue}</div>;
  }
};

export default CustomCell;
